<template>
    <el-drawer
        title="选择题目"
        :visible.sync="show"
        :wrapperClosable="false"
        direction="rtl"
        size="80%"
        :before-close="close">
        <div class="panel fx-g1">
            <el-tabs v-model="currentTab" >
                <el-tab-pane label="添加单选填空题" name="addQuestion">
                    <div class="fx-g1"  element-loading-text="数据处理中，请稍后...">
                        <el-form :inline="true" :model="form" >
                            <el-form-item label="关键词">
                                <el-input v-model="form.keywords" clearable placeholder="关键词"></el-input>
                            </el-form-item>
                            <el-form-item label="类型">
                                <el-select v-model="form.type" clearable placeholder="类型">
                                    <el-option
                                        v-for="item in types"
                                        :key="item.optionValue"
                                        :label="item.optionText"
                                        :value="item.optionValue">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="分类">
                                <el-select v-model="form.categoryId" clearable placeholder="分类">
                                    <el-option
                                        v-for="item in trainCategorys"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-form>
                        <el-table
                            :data="tableData"
                            stripe
                            style="width: 100%;"
                            @selection-change="handleChoose"

                        >
                            <el-table-column
                                type="selection"
                                width="55">
                            </el-table-column>
                            <el-table-column
                                min-width="180"
                                prop="questionFormHtml"
                                label="题目" >
                            </el-table-column>
                            <el-table-column
                                min-width="180"
                                prop="categoryName"
                                label="分类" >
                            </el-table-column>
                            <el-table-column
                                min-width="120"
                                prop="optName"
                                label="语言类型" >
                            </el-table-column>
                            <el-table-column property="date" label="知识点" min-width="250">
                                <template slot-scope="scope">
                                    <tag-group :tags="scope.row.knowledgeArray" size="medium"></tag-group>
                                </template>
                            </el-table-column>
                            <el-table-column
                                min-width="120"
                                label="标签">
                                <template slot-scope="scope">
                                    <tag-group :tags="scope.row.tagNames"></tag-group>
                                </template>
                            </el-table-column>
                            <el-table-column
                                min-width="180"
                                prop="typeName"
                                label="类型" >
                            </el-table-column>
                            <el-table-column
                                min-width="180"
                                prop="answer"
                                label="答案" >
                            </el-table-column>
                            <el-table-column
                                min-width="180"
                                prop="difficulty"
                                label="难度" >
                            </el-table-column>
                        </el-table>
                    </div>
                </el-tab-pane>
                <el-tab-pane label="添加操作题" name="subOperation">
                    <div class="fx-g1" v-loading="showLoading" element-loading-text="数据处理中，请稍后...">
                        <el-form ref="form" :model="form2" label-width="80px" class="edit_form" :inline="true">
                            <el-form-item label="关键词">
                                <el-input v-model="form2.keywords" suffix-icon="el-icon-search" style="width: 340px;margin-right: 20px"></el-input>
                            </el-form-item>
                            <el-cascader placeholder="任务知识点筛选"
                                v-model="form2.knowledgeIds"
                                :options="options"
                                :props="{expandTrigger: 'hover'}"
                                @change="handleChange"
                                style="width: 300px;" clearable
                            >
                            </el-cascader>

                        </el-form>

                        <el-table
                            :data="operationList"
                            stripe

                            style="width: 100%"
                            @selection-change="handleOperationChoose"
                        >
                            <el-table-column
                                type="selection"
                                width="55">
                            </el-table-column>
                            <el-table-column property="date" label="任务" min-width="150">
                                <template slot-scope="scope">
                                    {{scope.row.title}}
                                </template>
                            </el-table-column>
                                <el-table-column property="date" label="知识点" min-width="250">
                                <template slot-scope="scope">
                                    <tag-group :tags="scope.row.knowledgeArray" size="medium"></tag-group>
                                </template>
                            </el-table-column>
                            <el-table-column
                                width="500"
                                label="资料">
                                <template slot-scope="scope">
                                    <div class="grid col-4 hgap-5">
                                        <div class="fx fx-c_center" v-if="scope.row.videos.length > 0">
                                            讲解视频：
                                                <el-button  type="text" @click="setShowResources(scope.row.videos)"  size="medium" class="text_warn">查看</el-button>
                                        </div>
                                        <div class="fx fx-c_center" v-if="scope.row.attachments.length > 0">
                                            随堂资料：
                                                <el-button type="text" @click="setShowResources(scope.row.attachments)" size="medium" class="text_warn">查看</el-button>
                                        </div>
                                        <div class="fx fx-c_center" v-if="scope.row.codes.length > 0">
                                            代码：
                                                <el-button type="text" @click="viewCode(scope.row.type,scope.row.codes[0].id)" size="medium" class="text_warn">查看</el-button>
                                        </div>
                                        <div class="fx fx-c_center" v-if="scope.row.tutorials.length > 0">
                                            卡片：
                                                <el-button type="text" @click="setShowResources(scope.row.tutorials)" size="medium" class="text_warn">查看</el-button>
                                        </div>
                                    </div>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                </el-tab-pane>
            </el-tabs>

            <ResourceDrawer :showBox="showResources" @play="play"
                        @close="showResources=false" label="资源列表" :resources="currentResources"></ResourceDrawer>
            <VideoDrawer v-if="showVideo" @close="showVideo=false" :url="currentVideo"></VideoDrawer>
        </div>
        <div class="panel_foot fx fx-m_end fx-c_center" v-if="currentTab=='addQuestion'">
            <el-pagination
                :background="true"
                prev-text="上一页"
                next-text="下一页"
                layout="prev, pager, next"
                :current-page="pager.currentPage"
                :page-size="pager.pageSize"
                :total="pager.dataTotal"
                @current-change="pageChange"
            >
            </el-pagination>
        </div>
        <div class="panel_foot fx fx-m_end fx-c_center" v-if="currentTab=='subOperation'">
            <el-pagination
                :background="true"
                prev-text="上一页"
                next-text="下一页"
                layout="prev, pager, next"
                :current-page="pager2.currentPage"
                :page-size="pager2.pageSize"
                :total="pager2.dataTotal"
                @current-change="pageChange2"
            >
            </el-pagination>
        </div>
        <span  class="fx fx-center">
            <el-button v-if="currentTab=='addQuestion'" type="primary" @click="sub()">添 加</el-button>
            <el-button v-else type="primary" @click="subOperation()">添 加</el-button>
            <el-button @click="close()">关 闭</el-button>
        </span>
    </el-drawer>
</template>

<style scoped>
.no_set {
    width: 55px;
    text-align: center;
}
.task_info{
    height: 40px;
    font-size: 12px;
    border-top: 1px solid var(--border);
}
.task_info:first-child{
    border-top: none;
}
.task_info .el-link {
    color: #f29100;
}
.lesson_info i.iconfont,.task_info i.iconfont {
    vertical-align: text-top;
}
.task_info > span {
    margin-right: 30px;
}
</style>


<script>
    import ResourceDrawer from '@/components/ResourceDrawer';
    import VideoDrawer from '@/components/VideoDrawer';
    export default {
        props: [
            "item"
        ],
        components: {
            ResourceDrawer,
            VideoDrawer,
        },
        data() {
            return {
                currentTab:"addQuestion",
                show: false,
                showLoading: false,
                showResources: false,
                showVideo: false,
                needRefreshParent: false,
                form: {
                    keywords: "",
                    enable: true,
                    categoryId:"",
                    examId : this.item.id,
                },
                form2: {},
                tableData: [],
                operationList: [],
                pager: {
                    pageSize: 12,
                    dataTotal: 0,
                    currentPage: 1
                },
                pager2: {
                    pageSize: 12,
                    dataTotal: 0,
                    currentPage: 1
                },
                choosedList: [],
                choosedOperationList: [],
                trainCategorys:[],
                trainTags:[],
                options: [],
                currentResources: [],
                types:[],
            }

        },
        watch: {
            "form": {
                handler: function (newValue) {
                    this.pager.currentPage = 1;
                    this.loadData();
                },
                deep: true
            },
            "form2": {
                handler: function (newValue) {
                    this.pager.currentPage = 1;
                    this.loadOperationData();
                },
                deep: true
            }
        },
        methods: {

            close() {
                if (this.needRefreshParent) {
                    this.$emit("submit");
                } else {

                    this.$emit("close");
                }
            },
            sub() {
                if (this.choosedList.length == 0) {
                    this.$showError("请选择后再操作");
                    return;
                } else {
                    let trainQuestions = this.choosedList.map(item => {
                        return {
                            id: item.id,
                        }
                    })
                    this.$ajaxPost("/question/addQuestions", {
                        examId: this.form.examId,
                        list: trainQuestions
                    }, data => {
                        this.$showSuccess("保存成功", 1200, ()=>{
                            this.loadData();
                            this.needRefreshParent = true;
                            this.$emit("submit");
                        });
                    })
                }
                return false;
            },
            subOperation() {
                this.showLoading = true;
                if (this.choosedOperationList.length == 0) {
                    this.$showError("请选择后再操作");
                    return;
                } else {
                    let trainQuestions = this.choosedOperationList.map(item => {
                        return {
                            id: item.id,
                        }
                    })
                    this.$ajaxPost("/question/addOperationQuestions", {
                        examId: this.form.examId,
                        list: trainQuestions
                    }, data => {
                        this.$showSuccess("保存成功", 1200, ()=>{
                            this.showLoading = false;
                            this.loadOperationData();
                            this.needRefreshParent = true;
                            this.$emit("submit");
                        });
                    })
                }
                return false;
            },
            handleChoose(val) {
                this.choosedList = val;
            },
            handleOperationChoose(val) {
                this.choosedOperationList = val;
            },
            setShowResources(resources) {
                this.currentResources = resources;
                this.showResources =true;
            },
            viewCode(type,id) {
                this.$goEditCode(type, `isplatform=true&mode=caseview&id=${id}`);
            },
            play(url) {
                this.currentVideo = url;
                this.showVideo = true;
            },
            loadData() {
                //let data = {"keywords": this.form.keywords,"categoryId":this.form.categoryId,"knowledgeIds":this.form.knowledgeIds};
                let data = {...this.form};
                this.$ajaxPost("/trainQuestion/getTrainQuestionListByPlatform", {
                    form: data,
                    pager: {...this.pager, dataTotal: 0}
                }, (data) => {
                    //分页不能带offset，否则会影响后台计算最新offset
                    let {offset, ...pager} = data.pager;
                    this.pager = pager;
                    this.tableData = data.result;
                })
            },
            loadOperationData() {
                let data = {"keywords": this.form2.keywords,"knowledgeIds":this.form2.knowledgeIds};
                this.$ajaxPost("/lessonTask/listByPlatFormId", {
                    form: data,
                    pager: {...this.pager2, dataTotal: 0}
                }, (data) => {
                    //分页不能带offset，否则会影响后台计算最新offset
                    let {offset, ...pager} = data.pager;
                    this.pager2 = pager;
                    let items = data.result;
                    items.forEach(item => {
                        item.videos = item.resources.filter(r => r.category == 1);
                        item.attachments = item.resources.filter(r => r.category == 2);
                        item.codes = item.resources.filter(r => r.category == 3);
                        item.tutorials = item.resources.filter(r => r.category == 4);
                    })
                    this.operationList = items;
                })
            },
            pageChange(page) {
                this.pager.currentPage = page;
                this.loadData();
            },
            pageChange2(page) {
                this.pager2.currentPage = page;
                this.loadOperationData();
            },
            loadTrainCategory() {
                this.$ajaxGet("/trainCategory/listOption/1", (data) => {
                     this.trainCategorys = data.result;
                })
            },
            handleChange(value) {
                console.log(value);
            },
            loadFuncs() {
                let datas = {"type": this.form.optType};
                this.$ajaxPost("/knowledge/knowledgeByTask",{form:datas} , (data) => {//knowledgeTree
                    this.options = data.result;
                })
            },
            loadType() {
                this.$ajaxGet("/trainQuestion/questionTypes", (data) => {
                    this.types = data.result;
                })
            },
        },
        mounted() {
            this.show = true;
        },
        created() {
            this.loadData();
            this.loadTrainCategory();
            this.loadOperationData();
            //this.loadTrainTag();
            this.loadFuncs();
            this.loadType();
        }
    }
</script>
